<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          User Profile
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>First Name</label>
              <md-input
                v-model="organization.primaryContact.firstName"
                v-on:input="emitDirty('primaryContact', 'firstName')"
                v-on:blur="validateProfile($v.organization.primaryContact.firstName)"
                type="text"
                data-tour="first_name"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Last Name</label>
              <md-input
                v-model="organization.primaryContact.lastName"
                v-on:input="emitDirty('primaryContact', 'lastName')"
                v-on:blur="validateProfile($v.organization.primaryContact.lastName)"
                type="text"
                data-tour="last_name"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Email Address</label>
              <md-input
                v-model="organization.primaryContact.emailAddress"
                type="email"
                data-tour="email"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Phone Number</label>
              <md-input
                v-model="organization.primaryContact.phoneNumber"
                v-on:input="emitDirty('primaryContact', 'phoneNumber')"
                v-on:blur="validateProfile($v.organization.primaryContact.phoneNumber)"
                type="text"
                data-tour="phone_number"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import validationRules from '../../validationRules';
export default {
  name: "edit-profile-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    organization: {},
    ogOrganization: {}
  },
  computed: {
    provider: function() {
      if (this.organization.userIds.length > 0) {
        return this.organization.userIds[0].split("|")[0];
      }
      return "";
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateProfile: function(input){
      input.$touch();
      if (input.$error){
        var warningMessage = "";
        if (input == this.$v.organization.primaryContact.firstName || input == this.$v.organization.primaryContact.lastName){
          warningMessage = "Name is required.";
        }
        else if (input == this.$v.organization.primaryContact.phoneNumber) {
          warningMessage = "Phone number must be at least 10 digits in length.";
        }
        this.$store.commit("pushError", warningMessage);
      }
    },  
    emitDirty: function(p, q) {
      // Getting around Vue's weirdness with making values that were null into empty strings.
      if (p && q) {
        if (
          this.organization[p][q] === "" &&
          this.ogOrganization[p][q] === null
        ) {
          this.organization[p][q] = null;
        }
      } else if (
        this.organization[p] === "" &&
        this.ogOrganization[p] === null
      ) {
        this.organization[p] = null;
      }
      // eslint-disable-next-line
      this.$emit("dirty", "primaryContact", !_.isEqual(this.organization, this.ogOrganization));
    }
  },
  validations () {
    return validationRules;
  }
};
</script>
<style></style>
